import { ATB_APPLICATION_BASENAME, LIB_CONSUMER } from "constants/common";

export const navigateTo = (url, newTab = false) => {
  window.open(url, newTab ? "_blank" : "_self");
};

export const navigateHandler = ({ history, source, path, baseName, newTab }) => {
  if (source === LIB_CONSUMER.ATB) {
    history.push(path);
  } else {
    const { origin } = window.location;
    const basePath = baseName || ATB_APPLICATION_BASENAME;

    const url = origin + basePath + path;
    navigateTo(url, newTab);
  }
};

export const appendBetaInUrl = (url) => {
  const pathname = window.location.pathname;

  if (pathname.includes("/beta") && !url.includes("/beta")) {
    if (
      url.includes("business/thanksforbusiness/") &&
      !url.includes("business/thanksforbusiness/login/") &&
      !url.includes("business/thanksforbusiness/bill-payment/")
    ) {
      return url.replace("business/thanksforbusiness/", "business/thanksforbusiness/beta/");
      // replacing acquisition's URLs below
    } else if (url.includes("business/b2b/internet-leased-line/acquisition/check-feasibility")) {
      return url.replace(
        "business/b2b/internet-leased-line/acquisition/check-feasibility",
        "business/b2b/beta/internet-leased-line/acquisition/check-feasibility",
      );
    } else if (url.includes("business/b2b/broadband-internet/check-feasibility")) {
      return url.replace(
        "business/b2b/broadband-internet/check-feasibility",
        "business/b2b/beta/broadband-internet/check-feasibility",
      );
    } else if (url.includes("business/enterprise-hub/acquisition/cocp")) {
      return url.replace("business/enterprise-hub/acquisition/cocp", "business/enterprise-hub/beta/acquisition/cocp");
    } else if (url.includes("business/b2b/acquisition/pricing-quotation")) {
      return url.replace("business/b2b/acquisition/pricing-quotation", "business/b2b/beta/acquisition/pricing-quotation");
    } else if (url.includes("business/b2b/landline/sip-trunk")) {
      return url.replace("business/b2b/landline/sip-trunk", "business/b2b/beta/landline/sip-trunk");
    }
  }
  return url;
};
